'use client';

import { OutageMessageBanner } from './outage-message-banner';
import { CMC_OUTAGE_MESSAGE } from 'constants/storageConstants';
import { setCookie } from 'utils/cookieUtils';

const CmcOutageMessage = ({
  allDealerContent
}: Readonly<{ allDealerContent: string }>) => {
  const handleOutageMassageClose = () => {
    setCookie(CMC_OUTAGE_MESSAGE, false);
  };

  return (
    <OutageMessageBanner
      heading={allDealerContent}
      handleOutageMassageClose={handleOutageMassageClose}
    />
  );
};
export default CmcOutageMessage;
